import React from 'react'
import cn from 'classnames'
import PinIcon from 'components/PinIcon'
import { Flex } from 'shared/ui'

import { translate } from './util'
import Count from './Count'
import SortMenu from './SortMenu'
import styles from './styles.less'

const Narrow = ({
  canSeePinnedSearches,
  isFreeFormSearch,
  isSearchPinnable,
  isSelectionMode,
  onPinUnpinClick,
  pinnedSearch,
  searchIsFolderSearch,
  title,
  CountComponent = Count,
  SortMenuComponent = SortMenu,
}) => {
  const getTitleLabel = () => {
    if (isFreeFormSearch) return 'Search results'
    if (searchIsFolderSearch) return title
    return translate(title)
  }

  const titleComponent = (
    <div
      className={cn(styles.title, {
        [styles.bulk]: isSelectionMode,
      })}
    >
      <div className="grui flex overflow-hidden items-baseline">
        <span className={cn(styles.titleLabel, styles.ellipsis)}>
          {getTitleLabel()}
        </span>
        <CountComponent />
      </div>
    </div>
  )

  return (
    <div
      className={cn(
        styles['conversation-list-header-wide'],
        'conversation-list-header-title-bar'
      )}
    >
      <div className={styles.top}>
        <div className={styles.topCenter}>{titleComponent}</div>
        <Flex className={styles.topRight}>
          {canSeePinnedSearches &&
            isSearchPinnable && (
              <PinIcon
                size="small"
                enabled={!isSelectionMode}
                isPinned={!!pinnedSearch}
                onPinClick={onPinUnpinClick}
              />
            )}
          <SortMenuComponent />
        </Flex>
      </div>
    </div>
  )
}

export default Narrow
